export default {
    about_doctor: "Həkim haqqında",
    account_manager: "Hesab meneceri",
    activated: "Aktivləşdirilib",
    additional_info: "Əlavə məlumat",
    administrator: "Administrator",
    administrators: "Administratorlar",
    amount_of_doctors: "Həkimlərin sayı",
    are_you_sure_you_want_to_delete_field: "Göndərişi silmək istədiyinizə əminsiniz?",
    assistants: "Assistentlər",
    backup_code: "Yedək kodu",
    block: "Blokla",
    block_noun: "Blok",
    browse_computer: "Fayllardan seçin",
    by_cabinets: "Ofis tərəfindən",
    by_days: "Günlər üzrə",
    by_days_of_week: "Həftənin günləri üzrə",
    by_even_days: "Cüt günlər üzrə",
    by_odd_days: "Tək günlər üzrə",
    cabinet: "kabinet",
    cabinets: "Şkaflar",
    chair: "Kreslo",
    chairs: "Kreslolar",
    clinic_access_request: "Klinikaya giriş tələbi",
    config: "Konfiqurasiya",
    confirm_password: "Parolu təkrar daxil edin",
    curator: "Kurator",
    curators: "Kuratorlar",
    dentist_plus_tech_support_requests_access_to_your_clinic: "Dentist+ Texniki dəstək kliniyanıza giriş tələb edir",
    doctor_position: "Həkimin vəzifəsi",
    doctor_specialty: "Həkimin ixtisası",
    enter_backup_code_note: "İki faktorlu autentifikasiyanı aktivləşdirdiyiniz zaman aldığınız ehtiyat kodlardan birini daxil edin. Nəzərə alın ki, hər bir ehtiyat kodu yalnız bir dəfə istifadə edilə bilər",
    enter_code_from_authorization_app: "Telefonunuzdakı iki faktorlu autentifikasiya proqramından kodu daxil edin",
    field: "İstiqamət",
    fields: "İstiqamətlər",
    functionality: "Funksional",
    login_and_password: "Login və parol",
    manual_pay_system: "Əl ilə ödəmə sistemi",
    not_worked: "İşlənməyib",
    partner: "Tərəfdaş",
    password_does_not_match_confirmation: "Parol təsdiqlə uyğun gəlmir",
    password_requirement_min_length: "Ən azı {min} simvol",
    password_requirement_mixed_case: "Latın böyük və kiçik hərfləri",
    password_requirement_number: "Rəqəm mütləqdir",
    password_requirement_symbol: "Xüsusi simvol mütləqdir",
    percent: "Faiz",
    period_from: "Dövr başlayır",
    period_to: "Dövr bitir",
    phone2: "Əlavə telefon",
    profession: "İxtisas",
    rate: "Dərəcə",
    rate_per_day: "Günlük dərəcə",
    rate_per_hour: "Saatlıq dərəcə",
    rate_per_month: "Aylıq dərəcə",
    reserve_codes: "Ehtiyat kodları",
    roles: "Rollar",
    sale_good_percent: "Mal satışından faiz",
    schedule_conflicts_found: "Cari yazılarla cədvəl konfliktləri tapıldı",
    seller: "Satıcı",
    staff: "Personal",
    take_photo: "Foto çəkin",
    technics: "Texniklər",
    turn_on: "Yandırın",
    turned_off: "Əlil",
    two_factor_authorization: "İki faktorlu autentifikasiya",
    two_factor_authorization_setup_successfully: "İki faktorlu autentifikasiya uğurla aktivləşdirildi",
    twofactor_setup_instructions: "<ul><li>App Store və ya Google Play-dən autentifikator tətbiqini (məsələn, Google Authenticator, Microsoft Authenticator, Yandex.Key) endirin.</li><li>Telefonunuzdakı proqramda 'Kod əlavə et'/'+' üzərinə klikləyin və kompüterinizin ekranında göstərilən QR kodunu skan edin.</li><li>Aşağıdakı 6 rəqəmli QR kodu yaratmaq üçün müvafiq tətbiq sahəsinə daxil edin. bağlamalar</li><li>Telefonunuzu itirdiyiniz halda təklif olunan ehtiyat kodları (6 rəqəmli kodu yoxladıqdan sonra görünəcək) təhlükəsiz yerdə yadda saxladığınızdan əmin olun</li></ul>",
    use_app_code: "Standart kodu istifadə edin",
    use_backup_code: "Yedək kodu istifadə edin",
    user_data: "İstifadəçi məlumatları",
    user_will_assigned_rights_selected_for_that_role: "İstifadəçiyə bu rol üçün seçilmiş hüquqlar təyin ediləcək",
    weekend: "İstirahət günü",
    without_warehouse_form_note: "Anbarla bağlı olmadan, materiallar əsas anbardan və ya kresloya bağlı anbardan silinəcək",
    work_day: "İş günü",
    work_days: "İş günləri",
    work_schedule: "İş qrafiki",
    work_time: "İş vaxtı",
    worked: "İşlənib"
}
